import { ApiCallError } from 'app/http/ApiCallError';

const FALLBACK_MESSAGE = 'Unable to accept the invitation';

export const getAcceptInvitationErrorMessage = (error: unknown): string => {
  if (!(error instanceof ApiCallError) || typeof error.body !== 'object' || error.body === null) {
    return FALLBACK_MESSAGE;
  }

  const { message } = error.body as { message?: unknown };

  return typeof message === 'string' && message.trim() ? message : FALLBACK_MESSAGE;
};
